/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {LoadingService} from '../../shared/loading/loading-service/loading.service';
import {ActivatedRoute} from '@angular/router';
import {ClaimBaseModel} from '../../api/ms-claims/contracts/claim-base.model';
import {Subscription} from 'rxjs';
import {FileManagerApi} from '../../api/ms-filemanager/filemanager.api';
import {FileSummaryModel} from '../../api/ms-filemanager/contracts/file-summary.model';
import {ToastWrapperService} from '../../shared/utils/toast-wrapper-service/toast-wrapper-service';

@Component({
    selector: 'app-claim-attachments-page',
    templateUrl: './claim-attachments-page.component.html',
    styleUrls: ['./claim-attachments-page.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClaimAttachmentsPageComponent implements OnDestroy {

    public claim: ClaimBaseModel = {} as ClaimBaseModel;
    public files: FileSummaryModel[] = [];

    public fileManagerIsOffline = false;

    private subscriptions = new Subscription();

    constructor(private loadingService: LoadingService,
                private activatedRoute: ActivatedRoute,
                private fileManagerApi: FileManagerApi,
                private toast: ToastWrapperService) {

        this.subscriptions.add(
                this.activatedRoute.data.subscribe(data => {
                    this.claim.number = data.claimBase.number;
                    this.claim.referenceNumber = data.claimBase.referenceNumber;
                    this.claim.attachmentDirectory = data.claimBase.attachmentDirectory;
                    this.getClaimAttachments(this.claim.attachmentDirectory);
                }));
    }

    getClaimAttachments(directory: string): void {
        this.fileManagerApi.getDirectorySummary(directory)
                .subscribe(files => {
                    this.files = files;
                    this.fileManagerIsOffline = false;
                }, error => {
                    this.toast.error([
                        '<p>Orcan is not being able to provide the files uploading service at the moment.</p>',
                        '<p><strong>Please use the refresh button to reattempt a communication with the server.</strong></p>',
                    ].join('<br>'), 'Error');
                    this.fileManagerIsOffline = true;
                }).add(() => {
            this.loadingService.stop();
        });
    }

    getCssClass(): string {
        if (this.claim.referenceNumber == null) {
            return 'in-progress';
        } else {
            return 'reference-number';
        }
    }

    getReferenceNumberLabel(): string {
        if (this.claim.referenceNumber == null) {
            return 'In progress...';
        } else {
            return this.claim.referenceNumber;
        }
    }

    disableReferenceNumberTooltip(): boolean {
        return this.claim.referenceNumber != null;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    refreshAttachments = (): void => {
        this.loadingService.start();
        if (this.claim.attachmentDirectory != null) {
            this.fileManagerIsOffline = false;
            this.getClaimAttachments(this.claim.attachmentDirectory);
        } else {
            this.loadingService.stop();
        }
    };
}
